//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';

export enum CONTENT_DRAWER_ACTIONS {
  SET_DRAWER_SETTINGS = 'CONTENT_DRAWER_ACTIONS/SET_DRAWER_SETTINGS',
  SET_PAGE_DRAWER_SETTINGS = 'CONTENT_DRAWER_ACTIONS/SET_PAGE_DRAWER_SETTINGS',
}

export interface IContentDrawerState {
  drawerSettings: IContentDrawerSettings;
  pageDrawerSettings: IContentDrawerSettings;
}

export enum ContentDrawerBroadcastCalls {
  OpenDrawer = 'universal-upload:open-content-drawer',
  SetOverrideSettings = 'universal-upload:set-override-settings',
  UnsetOverrideSettings = 'universal-upload:unset-override-settings',
  SetPageSettings = 'universal-upload:set-page-settings',
  UnsetPageSettings = 'universal-upload:unset-page-settings',
}

interface IContentDrawerContextualHelpSettings {
  hideOnFilterChange?: boolean;
  icon?: string;
  message?: string;
}

export interface IContentDrawerFilters {
  distribution?: readonly string[];
  isDistributed?: readonly string[];
  mediaItemTypes?: readonly string[];
}

interface IContentDrawerFilterOptionsSettings {
  initialFilters?: IContentDrawerFilters;
  excludedSummaryKeys?: readonly string[];
  lockedKeys?: readonly string[];
}

interface IContentDrawerOption {
  name: string;
  key: string;
}

export interface IContentDrawerSettings {
  scope?: string;
  ctaText?: string;
  multiSelect?: boolean;
  multiSelectLimit?: number;
  contextualHelp?: IContentDrawerContextualHelpSettings;
  disableContentDrawer?: boolean;
  enableToastNotification?: boolean;
  useLegacyImageUploaderStyle?: boolean;
  filterOptions?: IContentDrawerFilterOptionsSettings;
  uploadText?: string;
  options?: readonly IContentDrawerOption[];
  disableImageUploader?: boolean;
  broadcastEventOverride?: (items: IContentLibraryItem[]) => void;
  shouldShowSchedulerForecasting?: boolean;
  isContentDrawerDroppableLayerActive?: boolean;
}
